// src/api/penalizacoes.js
import axios from 'axios';

/** Helpers para limpar “Resposta …” em qualquer payload */
const cleanLinha = (raw) => {
  if (!raw) return '';
  return String(raw)
    .replace(/^\uFEFF/, '')
    .trim()
    .replace(/^(?:Resposta|RESP\.?)[\s-]*/i, '')
    .replace(/\s+/g, '');
};

const deepCleanLinhas = (node) => {
  if (!node || typeof node !== 'object') return;
  if (Array.isArray(node)) { node.forEach(deepCleanLinhas); return; }
  for (const k of Object.keys(node)) {
    const v = node[k];
    const kl = k.toLowerCase();
    const isLinhaField =
      kl === 'linha' || kl === 'linhanumero' || kl === 'numerolinha' ||
      kl === 'dslinha' || kl === 'linhanome' || kl === 'numero_linha' ||
      kl === 'trajetonome' || kl === 'numerolinha';
    if (isLinhaField && typeof v === 'string') node[k] = cleanLinha(v);
    if (v && typeof v === 'object') deepCleanLinhas(v);
  }
};

// instancia axios - USANDO VARIÁVEL DE AMBIENTE
const API_BASE = process.env.REACT_APP_API_BASE || 'https://control-api-connectbus.viacaosaopedro.com';
console.log('🔍 penalizacoes.js - API_BASE (env):', process.env.REACT_APP_API_BASE);
console.log('🔍 penalizacoes.js - API_BASE (final):', API_BASE);

const penalApi = axios.create({
  baseURL: `${API_BASE}/api/penalizacoes`,
});

// interceptors (agora penalApi e deepCleanLinhas já existem)
penalApi.interceptors.request.use((cfg) => {
  try { deepCleanLinhas(cfg.data); } catch {}
  return cfg;
});

penalApi.interceptors.response.use((res) => {
  try { deepCleanLinhas(res.data); } catch {}
  return res;
});

export async function getPenalizacoesRelatorio(payload = {}) {
  const { data } = await penalApi.post('/relatorio', payload);
  return data;
}

export default penalApi;